export class Signal {
    constructor(initial) {
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "subs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Set()
        });
        this.value = initial;
    }
    get() {
        return this.value;
    }
    set(v) {
        if (Object.is(v, this.value))
            return;
        this.value = v;
        for (const fn of this.subs) {
            try {
                fn(v);
            }
            catch (err) {
                console.error("[Signal] subscriber threw", err);
            }
        }
    }
    update(fn) {
        this.set(fn(this.value));
    }
    subscribe(fn, immediate = true) {
        this.subs.add(fn);
        if (immediate)
            fn(this.value);
        return () => {
            this.subs.delete(fn);
        };
    }
}
